// extracted by mini-css-extract-plugin
export default {"select_itemsWrapper":"styleInputSearch_select_itemsWrapper__ZVfMo","select_item":"styleInputSearch_select_item__3F3SN"};